.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: var(--hs-chip-pad-y) var(--hs-chip-pad-x);
  border-radius: var(--hs-radius-full);
  font: var(--hs-type-caption);
  letter-spacing: var(--hs-caption-ls);
  white-space: nowrap;
}
.success {
  background: var(--hs-color-secondary-container);
  color: var(--hs-color-secondary-on-container);
}
.focus {
  background: var(--hs-color-primary-container);
  color: var(--hs-color-primary-on-container);
}
.locked {
  background: var(--hs-color-bg-subtle);
  color: var(--hs-color-text-secondary);
}
.accent {
  background: var(--hs-color-secondary-container-soft);
  color: var(--hs-color-secondary-deep);
}
.neutral {
  background: var(--hs-color-bg-muted);
  color: var(--hs-color-text-primary);
}
.danger {
  background: var(--hs-color-danger-container);
  color: var(--hs-color-danger-on-container);
}
.warning {
  background: var(--hs-color-warning-container);
  color: var(--hs-color-warning-on-container);
}
